import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Background-check endpoints handle all errors inline (payment errors,
      // Checkr failures, etc.) — never redirect away from the flow.
      const isBackgroundCheck = req.url.includes('/background-check/');

      // Subscription reads answer 404 to mean "this facility has never
      // subscribed" — the free tier, and the state the page exists to let an
      // admin change. Redirecting turns the most important moment in the flow,
      // the one before anybody has subscribed, into a Not Found page.
      const isSubscription = req.url.includes('/subscription');

      // The state background check answers 404 to mean "no admin has recorded
      // one yet" — the starting state for every professional, and one the
      // contractor's own profile page has to render normally. Matched on its
      // own rather than by widening the '/background-check/' test above, which
      // deliberately requires the slashes and does not cover this route.
      const isStateBackgroundCheck = req.url.includes(
        'state-background-check'
      );

      switch (error.status) {
        case 401:
          router.navigate(['/auth/login']);
          break;

        case 403:
          router.navigate(['/403']);
          break;

        case 404:
          if (
            !isBackgroundCheck &&
            !isSubscription &&
            !isStateBackgroundCheck &&
            !req.url.includes('/stripe/')
          ) {
            router.navigate(['/404']);
          }
          break;

        case 429:
          router.navigate(['/429']);
          break;

        case 500:
          if (!isBackgroundCheck) {
            router.navigate(['/500']);
          }
          break;

        case 503:
          if (!isBackgroundCheck) {
            router.navigate(['/503']);
          }
          break;

        default:
          console.error(`Unexpected error: ${error.status}`);
      }
      return throwError(() => error);
    })
  );
};
